import {
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { getCheckoutState } from '../getCheckoutState/getCheckoutState';
import { checkout } from '..';

interface UpdateFirstDrawAmountArgs {
  amount: number;
  estimatedPaymentAmount: string;
}

export function updateFirstDrawAmount() {
  const queryClient = useQueryClient();
  const { checkoutData } = getCheckoutState();

  const mutation = useMutation({
    mutationFn: async (arg: UpdateFirstDrawAmountArgs) => {
      const res = await checkout
        .post(`/v2/orchestration/update-first-draw-amount/${checkoutData?.checkoutUuid}?amount=${arg.amount}&estimatedPaymentAmount=${arg.estimatedPaymentAmount}`,
          null,
          {validateStatus: status => [200, 500].includes(status)}
        )
        .then((res) => {
          if (!(res.status >= 200 && res.status < 300)) throw res;
          return res.data;
        });
      await queryClient.invalidateQueries({
        queryKey: ['checkout'],
      });
      return res;
    },
    mutationKey: ['updateFirstDrawAmount', checkoutData?.checkoutUuid],
  });

  return {
    data: mutation.data,
    error: mutation.error,
    isMutating: mutation.isPending,
    trigger: mutation.mutateAsync,
    mutation,
  };
}

export default updateFirstDrawAmount;
